module.exports = __webpack_public_path__ + "static/media/17230027-Jfi1wSgs.2effba1c.JPG";